/* Fetches native Shopify product recommendations async and injects them.
   The server section renders empty until fetched with the recommendations URL. */
(function () {
  var el = document.querySelector('[data-recs]');
  if (!el || !el.dataset.url) return;
  fetch(el.dataset.url)
    .then(function (r) { return r.text(); })
    .then(function (text) {
      var html = new DOMParser().parseFromString(text, 'text/html');
      var fresh = html.querySelector('[data-recs]');
      if (fresh && fresh.innerHTML.trim().length) {
        el.innerHTML = fresh.innerHTML;
        // Cards are injected after the initial reveal scan — reveal them now
        // (no-op if the motion layer isn't loaded).
        if (window.vlxReveal) window.vlxReveal(el);
      }
    })
    .catch(function () { /* silent — recommendations are non-critical */ });
})();
